



























import {Component, Vue} from "vue-property-decorator";
import {namespace} from 'vuex-class';
import TestAlert from "@/components/UI/TestAlert.vue";
import SnackBar from "@/components/UI/SnackBar.vue";
import Layout from '@/Layout/Layout.vue';
import LayoutFull from '@/Layout/LayoutFull.vue';
import None from '@/Layout/None.vue';
import FullError from "@/components/UI/FullError.vue";
import ModalError from '@/components/UI/ModalError.vue';
import SupportDialog from "@/components/beta/SupportDialog.vue";
import Init from "@/components/beta/Init.vue";

const event = namespace('event')
const alerts = namespace('alerts')
const app = namespace('app')


@Component({
  name: 'App',
  components: {
    Init,
    SupportDialog,
    FullError,
    TestAlert,
    SnackBar,
    Layout,
    LayoutFull,
    None,
    ModalError
  }
})
export default class App extends Vue {
  @event.Getter('shows') protected shows: any
  @alerts.Getter('show') protected show: any
  @alerts.Getter('messages') protected messages: any
  @alerts.Getter('contentClass') protected contentClass: any
  @alerts.Getter('position') protected position: any
  @alerts.Getter('time') protected time: any
  @alerts.Getter('color') protected color: any
  @alerts.Getter('textColor') protected textColor: any
  @alerts.Getter('fontSize') protected fontSize: any
  @app.Getter('appLoaded') protected appLoaded: any



  get layout() {
    if (this.$route.meta && this.$route.meta.layout) {
      return (this.$route.meta.layout)
    }
    return 'None'
  }




}
